import {useEffect} from 'react';
import useIsLoggedIn from '@src/Providers/AuthProvider/useIsLoggedIn';
import {useAppDispatch} from '@src/Store/hooks';
import useMember from '@src/Store/selectors/useMember';
import {
  applyMtnTestLogin,
  hasActiveMtnTestLogin,
  isMtnTestMember,
  readMtnTestLogin,
} from './useMtnLoginCompletion';

/**
 * MTN test login (backend MTN_DB_DISABLED): keeps the user logged in across
 * page reloads. AuthProvider only knows Firebase users, so after it settles we
 * put the MTN member back into the store.
 */
export function useMtnTestSession() {
  const {isLoggedIn, isLoading, setIsLoggedIn} = useIsLoggedIn();
  const member = useMember();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isLoading) return;
    const testLogin = readMtnTestLogin();
    if (!testLogin || !hasActiveMtnTestLogin()) return;
    if (!isMtnTestMember(member?._id)) {
      applyMtnTestLogin(dispatch, testLogin);
    }
    if (!isLoggedIn) setIsLoggedIn(true);
  }, [isLoading, isLoggedIn, member?._id, dispatch, setIsLoggedIn]);
}

export default useMtnTestSession;
